import { IAuthConfig } from "./interfaces";
import { TokenStorage, AUTH_CONFIG_DEFAULTS } from "./helper";

export class AuthConfig implements IAuthConfig {
  GlobalHeaders: Array<Object>;
  HeaderName: string;
  HeaderPrefix: string;
  NoJwtError: boolean;
  TokenName: string;
  RefreshTokenName: string;
  TokenStorage: TokenStorage;

  constructor(config: IAuthConfig = {}) {
    for (const option in config) {
      this[option] = config[option];
    }

    for (const option in AUTH_CONFIG_DEFAULTS) {
      this[option] =
        config[option] != null ? config[option] : AUTH_CONFIG_DEFAULTS[option];
    }
  }
}
